<template>
  <div class="subscribe-form textbody">
    <h4>Receive news of future releases</h4>
    <p>Dovedale will be regularly realising new collections. We would like to keep you updated and informed. Please subscribe or contact us for custom orders.</p>
    <form id="subscribeForm" class="h8 nimbus-sans" :action="'//dovedaledesignstudio.us15.list-manage.com/subscribe/post?u=f5497669bd87e7e8a503aeb85&amp;id=' + mailchimpNewsletterID" method="post" name="mc-embedded-subscribe-form" target="_blank" @submit="submit">
      <input type="email" value="" placeholder="Your Email" name="EMAIL" id="mce-EMAIL" required>
      <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
      <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_f5497669bd87e7e8a503aeb85_a60f52dceb" tabindex="-1" value=""></div>
      <input type="submit" value="Sign Up" name="subscribe" id="mc-embedded-subscribe">
    </form>
  </div>
</template>

<script>
export default {
  name: 'SubscribeFrom',
  computed: {
    mailchimpNewsletterID () {
      const site = this.$store.state.site
      const id = site && site.data && site.data['site.mailchimp-newsletter-id']
      return id ? site.getText('site.mailchimp-newsletter-id') : ''
    }
  },
  methods: {
    submit () {
      this.$emit('submit')
      this.$el.querySelector('form').submit()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../style/variables';

.subscribe-form {
  h4{
    margin-bottom: 1em;
  }
}

form{
  margin-top: $gutter * 2;
  @include clearFloat();
  $gutter: $gutter*.75;
  input{
    float:left;
  }
  input[type="email"] {
    width:calc(100% * 2 / 3);
    margin-right: $gutter;
  }
  input[type="submit"] {
    width:calc(100% / 3 - #{$gutter});
    &:hover, &:focus, &:active {
      color:$white;
      background:$black;
      border-color:$black;
    }
  }
}
</style>



// WEBPACK FOOTER //
// SubscribeForm.vue?7ef88ade